module.exports = "<svg viewBox=\"0 0 24 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.847 6.568c.101.243.101.517 0 .761-.05.121-.122.23-.214.321v.001l-5.978 5.964c-.195.194-.449.291-.704.291-.255 0-.51-.097-.705-.291-.389-.388-.389-1.018 0-1.406l4.277-4.267H1.011c-.551 0-.997-.445-.997-.994 0-.549.446-.993.997-.993h19.512l-4.277-4.267c-.389-.388-.389-1.018 0-1.406.389-.388 1.02-.388 1.409 0l5.978 5.964v.001c.092.091.164.2.214.321z\" fill=\"#C9DEE9\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/images/svg/playbooks-card-arrow-right.svg
// module id = pGxX
// module chunks = 89